import {
  cyrb53hash,
  ensureTsPvAndFinalizeApplog
} from "./chunk-236RMLMX.js";

// src/pubsub/pub-pull.ts
import { Logger } from "besonders-logger";
var { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO);
function integratePub({ targetThread, agentHash, subID, pubData }) {
  const newLogs = pubData.thread.applogs.filter((log) => !targetThread.hasApplog(log, false));
  DEBUG(`[integratePub] integrating ${newLogs.length} logs`, { targetThread, subID, pubData });
  let toInsert = newLogs;
  if (subID) {
    toInsert = toInsert.concat(ensureTsPvAndFinalizeApplog(
      { en: subID, at: "subscription/cid", vl: pubData.cid.toString(), ag: agentHash },
      targetThread
    ));
  }
  targetThread.insertRaw(toInsert);
  return newLogs;
}

// src/pubsub/pubsub-types.ts
function isShare(obj) {
  return obj?.pk !== void 0 && obj?.lastPush !== void 0;
}
function isSubscription(obj) {
  return obj?.lastPull !== void 0;
}
function agentToShortHash(agentString) {
  return cyrb53hash(agentString, 31, 7);
}

export {
  integratePub,
  isShare,
  isSubscription,
  agentToShortHash
};
//# sourceMappingURL=chunk-DUMAGKG5.js.map